<div
    [attr.aria-expanded]="panelOpen"
    class="flex flex-col h-full animate-width-snappy overflow-hidden bg-p-content-background rounded-2xl shadow-p-form-field-shadow ml-auto border border-p-content-border-color"
    [ngClass]="{
        'bp908:w-[248px]': panelOpen,
        'w-16': !panelOpen,
    }">
    <fm-right-panel-header
        [showBackButton]="(contentStackService.currentConstentStackSize$ | async) > 0"
        [showReloadButton]="currentContent?.showRefreshButton"
        [sendToMainPanelUrl]="currentContent?.sendToMainPanelUrl"
        [panelOpen]="panelOpen"
        (back)="contentStackService.popContent()"
        (refreshSelected)="onRefreshSelected()"
        (togglePanel)="onPanelToggled()" />

    <div
        class="flex-1 flex flex-col w-full"
        [ngClass]="{
            'bp908:w-[248px]': panelOpen,
            'w-16': !panelOpen,
        }">
        @if (panelOpen) {
            <div
                class="w-full basis-0 grow overflow-hidden opacity-0"
                [class]="contentAnimationClass">
                @if (currentContent) {
                    <ng-container
                        *ngComponentOutlet="
                            currentContent.component;
                            inputs: currentContent.context
                        "></ng-container>
                } @else {
                    <fm-rp-home [panelOpen]="true" />
                }
            </div>
        } @else {
            <div class="w-full flex-1 overflow-hidden animation-fade-in">
                <fm-rp-home [panelOpen]="false" />
            </div>
        }
    </div>

    <!-- Sticky footer actions -->
    <div class="w-full p-4 border-t border-p-content-border-color flex justify-center items-center">
        @if (panelOpen) {
            <p-button
                [buttonProps]="{ autofocus: false }"
                (click)="openHelpFeedbackModal()"
                severity="secondary"
                [outlined]="true"
                class="w-full"
                styleClass="w-full">
                <div class="w-full flex items-center justify-start">
                    <fa-icon [icon]="faHandWave" style="font-size: 14px" />
                    <span class="ml-1 font-semibold">Help and Feedback</span>
                </div>
            </p-button>
        } @else {
            <p-button
                [buttonProps]="{ autofocus: false }"
                pTooltip="Help and Feedback"
                tooltipPosition="left"
                (click)="openHelpFeedbackModal()"
                size="small"
                styleClass="w-8 aspect-square !px-0"
                severity="secondary"
                [outlined]="true">
                <ng-template #icon>
                    <fa-icon [icon]="faHandWave" style="font-size: 14px" />
                </ng-template>
                <span class="sr-only">Help and Feedback</span>
            </p-button>
        }
    </div>
</div>
